import { render, staticRenderFns } from "./zzpList.vue?vue&type=template&id=df4c1f6a&scoped=true&"
import script from "./zzpList.vue?vue&type=script&lang=js&"
export * from "./zzpList.vue?vue&type=script&lang=js&"
import style0 from "./zzpList.vue?vue&type=style&index=0&id=df4c1f6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4c1f6a",
  null
  
)

export default component.exports